import { api } from "./api";
import { TCompanySize, TSector, TStage, TPaymentPeriodType } from "../../types/types"; 
import { TCompany, TCompanyOnboarding } from "../types/users.types";
import { TPlan } from "../types/utils.types";
import {
  ICompanyProvisioningStatus,
  IPaymentLinkResponse,
  onBoardingPaymentRequest,
  companyPaymentRequest,
} from "../types/onboardint.types";

export const onBoardingApi = api.injectEndpoints({
  endpoints: (build) => ({
    getCompanySizes: build.query<TCompanySize[], void>({
      query: () => ({
        url: "/OnBoarding/company-sizes",
        method: "GET",
      }),
      providesTags: ["CompanySizes"],
    }),
    getSectors: build.query<TSector[], void>({
      query: () => ({
        url: "/OnBoarding/sectors",
        method: "GET",
      }),
      providesTags: ["Sectors"],
    }),
    getPaymentPeriodTypes: build.query<TPaymentPeriodType[], void>({
      query: () => ({
        url: "Admintech/Admin_PaymentsPeriodTypes_DML/1",
        method: "POST",
        body: {name: 1},
      }),
      providesTags: ["paymentPeriodTypes"],
    }),
    getPlans: build.query<TPlan[], void>({
      query: () => ({
        url: "/OnBoarding/plans",
        method: "GET",
      }),
      providesTags: ["Plans"],
    }),
    
    saveOrUpdateCompany: build.mutation<TCompanyOnboarding, TCompanyOnboarding>({
      query: (company) => ({
        url: "/OnBoarding/saveOrUpdate",
        method: "POST", 
        body: company,
      }),
      invalidatesTags: (result, error, company) => [
        "CompanySizes", 
        "Sectors", 
        "Plans",
        { type: "Company", id: company.id },
      ],
    }),
    getProvisioningStatus: build.query<ICompanyProvisioningStatus, string>({
      query: (guid) => ({
        url: `/OnBoarding/provisioning-status/${guid}`,
        method: "GET",
      }),
    }),
    getPaymentLink: build.mutation<IPaymentLinkResponse, {
      name?: string;
      phone?: string;
      email?: string;
      plansId?: number;
      paymentsPeriodTypesId?: number;
      companyId?: number;
      contactFullName?: string;
    }>({
      query: (body) => ({
        url: '/Payments/GetPaymentLink',
        method: 'POST',
        body,
      }),
    }),
    setupRecurringPayment: build.mutation<IPaymentLinkResponse, onBoardingPaymentRequest>({
      query: (body) => ({
        url: '/payments/onBoardingPayment/1', // 1 = Add, anonymous — identified by companyGuid
        method: 'POST',
        body,
      }),
      invalidatesTags: ["Plans"],
    }),
    companyPayment: build.mutation<IPaymentLinkResponse, companyPaymentRequest>({
      query: (body) => ({
        url: '/payments/companyPayment/1', // 1 = Add, authenticated — identified by companyId
        method: 'POST',
        body,
      }),
      invalidatesTags: (_result, _error, { companyId }) => [
        "Plans",
        { type: "CompanySubscription" as const, id: companyId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCompanySizesQuery,
  useGetSectorsQuery,
  useGetPaymentPeriodTypesQuery,
  useGetPlansQuery,
  useSaveOrUpdateCompanyMutation,
  useLazyGetProvisioningStatusQuery,
  useGetPaymentLinkMutation,
  useSetupRecurringPaymentMutation,
  useCompanyPaymentMutation,
} = onBoardingApi;
